module.exports = __webpack_public_path__ + "img/底部logo.8149028f.8149028f.png";